export const pubSubMock = {
  subscribe(message: string, func: (message: string, data: any) => any): string {
    return 'fakeUuid';
  },
  GetRegisterMessegeeNames: () => [],
  publishSync(_name: string, _value: any) {},
  publish(_name: string, _value: any) {},
  unsubscribe: (_token: string) => false,
  getMessageNames: () => [],
};
